<script lang="ts">
    import { onMount } from "svelte";
    import { selectedLanguageCode } from "./store";
    import { LocalizationTexts, localizedTexts } from "./texts";

    let texts: LocalizationTexts = localizedTexts.de;

    onMount(() => {
        selectedLanguageCode.subscribe((language) => {
            texts = localizedTexts[language];
        });
    });
</script>

<div class="flex flex-col justify-center items-center">
    <h1 class="text-2xl font-bold text-center">
        {texts.thankYouHeading}
    </h1>
    <p class="text-center">
        {texts.thankYouText}
    </p>
</div>
